import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-media-preview',
  templateUrl: './media-preview.component.html',
  styleUrls: ['./media-preview.component.scss']
})
export class MediaPreviewComponent implements OnInit {
  @Input() title: string;
  @Input() type: string;
  @Input() url: string;

  constructor() {}

  ngOnInit(): void {}
}
